import { Title } from "./../Typography";
import { CorporateButton } from "./../CorporateButton";
import { MediaLibraryItem } from "../../generated/graphql";
import { MobileDownloadIcon } from "../Icons/icons";
import { FileInfo } from "./FileInfo";
import { MediaLibraryItemButton, MediaLibraryItemWrapper } from "./styles";
import { Thumbnail } from "./Thumbnail";
import { getCopy } from "../../lib/utils/getCopy";

interface IProps {
  item: MediaLibraryItem;
  onItemClick: Function;
  pathname: string;
  showPreviewButton?: boolean;
  thumbnailCursor?: boolean;
  copy: any[];
}

export const MediaLibraryItemComponent = ({ item, onItemClick, pathname, copy, showPreviewButton = true, thumbnailCursor = true }: IProps) => {
  const itemUrl = `${pathname}/?id=${item.id}`;
  return <MediaLibraryItemWrapper>
    <div className="w-full text-left mb-4 md:mb-0">
      <Thumbnail thumbnailCursor={thumbnailCursor} item={item} itemUrl={itemUrl} onItemClick={onItemClick} />
      <FileInfo {...item?.assetComponent?.asset[0]} />
      <Title type="xxxs" tag="p">{item?.title}</Title>
    </div>
    <div className="w-full flex">
      <a href={item?.assetComponent?.asset[0]?.url} className="mr-2 text-white"
        download={item?.assetComponent?.asset[0]?.fileName}
        target="_blank"
        rel="noreferrer">
        <CorporateButton
          color="tertiary"
          type="lead"
          icon={<MobileDownloadIcon />}
        />
      </a>
      {showPreviewButton &&
        <CorporateButton
          color="tertiary"
          type="lead"
          label={getCopy('preview', copy)}
          onClick={e => onItemClick(e, item.id)} />
      }
    </div>
  </MediaLibraryItemWrapper>
}